<div class="organizer-shared-calendar">
  <app-tab-buttons-group
    *ngIf="showViews"
    class="organizer-shared-calendar__select-view"
    [ngModel]="view"
    (ngModelChange)="updateView($event)"
    [buttonsConfig]="tabButtonsGroupViewsConfig"
  ></app-tab-buttons-group>
  <div
    class="organizer-shared-calendar__calendar"
    [class.organizer-shared-calendar__calendar--clickable-timeslots]="
      clickableTimeslots
    "
    #calendar
  ></div>
</div>
